import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { sectionVariants, cardVariants, textRevealVariants } from '../utils/animations';
import SectionContainer from './SectionContainer';

const Contact = ({ data }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setSubmitStatus('Thank you for your message! I\'ll get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
    setIsSubmitting(false);
    
    setTimeout(() => setSubmitStatus(''), 5000);
  };

  return (
    <SectionContainer id="contact" variants={sectionVariants}>
      <motion.div
        className="contact-content"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.div variants={textRevealVariants}>
          <h2 className="section-title">Contact</h2>
        </motion.div>
        
        <motion.div
          className="contact-grid"
          variants={cardVariants}
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: isMobile ? 'var(--gap-md)' : 'var(--gap-lg)',
            marginTop: 'var(--gap-lg)'
          }}
        >
          <motion.div
            className="contact-info glass-card"
            variants={cardVariants}
            style={{ 
              padding: isMobile ? '1.5rem' : 'var(--card-padding)',
              gridColumn: isMobile ? '1' : '1 / -1'
            }}
          >
            <h3 
              style={{ 
                fontSize: isMobile ? '1.3rem' : '1.5rem',
                fontWeight: '600',
                marginBottom: 'var(--gap-md)',
                color: 'var(--dusty-rose)'
              }}
            >
              {data?.contact?.headline || "Let's connect."}
            </h3>
            <p 
              className="text-secondary" 
              style={{ 
                lineHeight: 1.6,
                fontSize: isMobile ? '1rem' : '1.1rem'
              }}
            >
              {data?.contact?.blurb || ''}
            </p>

            <p className="text-secondary" style={{ 
              lineHeight: 1.6, 
              marginBottom: 'var(--gap-md)',
              fontSize: isMobile ? '1rem' : '1.1rem'
            }}>
              If you're hiring for backend/full-stack roles or want to collaborate, send a note, I reply quickly.
            </p>
            
            <div style={{ 
              display: 'grid', 
              gap: 'var(--gap-md)',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))'
            }}>
              <div>
                <strong style={{ color: 'var(--text-primary)', fontSize: isMobile ? '0.95rem' : '1rem' }}>Email:</strong>
                <div>
                  <a 
                    href={`mailto:${data?.email || ''}`}
                    style={{
                      color: 'var(--dusty-rose)',
                      textDecoration: 'none',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      wordBreak: 'break-word'
                    }}
                  >
                    {data?.email || ''}
                  </a>
                </div>
              </div>
              
              <div>
                <strong style={{ color: 'var(--text-primary)', fontSize: isMobile ? '0.95rem' : '1rem' }}>Location:</strong>
                <div>
                  <a 
                    href={data?.locationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: 'var(--sage-green)',
                      textDecoration: 'none',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      wordBreak: 'break-word'
                    }}
                  >
                    {data?.location || ''}
                  </a>
                </div>
              </div>
            </div>

            <div style={{ 
              display: 'grid', 
              gap: 'var(--gap-md)',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))',
              marginTop: '10px',
            }}>
              <div>
                <strong style={{ color: 'var(--text-primary)', fontSize: isMobile ? '0.95rem' : '1rem' }}>Linkedin:</strong>
                <div>
                  <a 
                    href={`mailto:${data?.linkedin || ''}`}
                    style={{
                      color: 'var(--dusty-rose)',
                      textDecoration: 'none',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      wordBreak: 'break-word'
                    }}
                  >
                    {data?.linkedin || ''}
                  </a>
                </div>
              </div>
              
              <div>
                <strong style={{ color: 'var(--text-primary)', fontSize: isMobile ? '0.95rem' : '1rem' }}>GitHub:</strong>
                <div>
                  <a 
                    href={data?.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: 'var(--sage-green)',
                      textDecoration: 'none',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      wordBreak: 'break-word'
                    }}
                  >
                    {data?.github || ''}
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

        </motion.div>
      </motion.div>
    </SectionContainer>
  );
};

export default Contact;
